import { Typography, styled } from '../../../base';

export const StyledHeaderText = styled(Typography)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.secondary,
}));

